export const PROJECTS=
        [
           {
                "PId":"P1",
                "title":"Personal Portfolio Website",
                "image":require("../images/project-3.jpeg"),
                "files":[
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg")
                ],
                "text":"This is an amazing portfolio website totally made by me.Updates will be added as time will pass.This is a full stack mern web-application developed by Abuzar",
                "type":"Web",
                "duration":"1 week"
            },
            {
                "PId":"P2",
                "title":"Fresh Website using Next.js",
                "image":require("../images/project-1.jpg"),
                "files":[
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg")
                ],
                "text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vehicula elementum nisl vel sollicitudin. Quisque pellentesque odio ac eros efficitur, vitae luctus arcu vulputate. Mauris eleifend finibus odio eu porttitor. In scelerisque congue mattis. Vestibulum varius magna quis felis commodo molestie. Integer tincidunt pharetra efficitur. Curabitur quis orci vehicula, gravida massa sed, porttitor nisi. Aliquam venenatis diam lorem, eget porta ligula ultricies sit amet. Nunc non eros lectus. Phasellus sit amet felis a nulla sollicitudin lacinia non ac lectus. In eleifend neque eget commodo tempus. Maecenas ut urna sollicitudin eros posuere tristique. In hac habitasse platea dictumst. Vestibulum in iaculis ligula. Nulla vel euismod sem.",
                "type":"Web",
                "duration":"2 week"
            },
            {
                "PId":"P3",
                "title":"Semantic Analysis using python",
                "image":require("../images/project-2.jpg"),
                "files":[
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg")
                ],
                "text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vehicula elementum nisl vel sollicitudin. Quisque pellentesque odio ac eros efficitur, vitae luctus arcu vulputate. Mauris eleifend finibus odio eu porttitor. In scelerisque congue mattis. Vestibulum varius magna quis felis commodo molestie. Integer tincidunt pharetra efficitur. Curabitur quis orci vehicula, gravida massa sed, porttitor nisi. Aliquam venenatis diam lorem, eget porta ligula ultricies sit amet. Nunc non eros lectus. Phasellus sit amet felis a nulla sollicitudin lacinia non ac lectus. In eleifend neque eget commodo tempus. Maecenas ut urna sollicitudin eros posuere tristique. In hac habitasse platea dictumst. Vestibulum in iaculis ligula. Nulla vel euismod sem.",
                "type":"DataScience",
                "duration":"2 week"
            },
            {
                "PId":"P4",
                "title":"Grades Prediction using Random Forest",
                "image":require("../images/project-4.jpg"),
                "files":[
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg"),
                    require("../images/project-2.jpg")
                ],
                "text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vehicula elementum nisl vel sollicitudin. Quisque pellentesque odio ac eros efficitur, vitae luctus arcu vulputate. Mauris eleifend finibus odio eu porttitor. In scelerisque congue mattis. Vestibulum varius magna quis felis commodo molestie. Integer tincidunt pharetra efficitur. Curabitur quis orci vehicula, gravida massa sed, porttitor nisi. Aliquam venenatis diam lorem, eget porta ligula ultricies sit amet. Nunc non eros lectus. Phasellus sit amet felis a nulla sollicitudin lacinia non ac lectus. In eleifend neque eget commodo tempus. Maecenas ut urna sollicitudin eros posuere tristique. In hac habitasse platea dictumst. Vestibulum in iaculis ligula. Nulla vel euismod sem.",
                "type":"DataScience",
                "duration":"2 week"
            }

        ]